import { render, staticRenderFns } from "./CancelView.vue?vue&type=template&id=1a5bcb70&scoped=true&"
import script from "./CancelView.vue?vue&type=script&lang=js&"
export * from "./CancelView.vue?vue&type=script&lang=js&"
import style0 from "./CancelView.vue?vue&type=style&index=0&id=1a5bcb70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5bcb70",
  null
  
)

export default component.exports